import map from "lodash/map"

class FlatVariant {
  constructor(value, title) {
    this.value = value;
    this.title = title;
  }
}

class HousingShortNamesVariant {
  constructor(value, title) {
    this.value = value;
    this.title = title;
  }    
}

export class GetFilterParamsResponse {
  constructor(responseJSON) {
    this.responseJSON = responseJSON;
  }

  /** @returns {FlatVariant[]} */
  getFlatVariants() {
    return map(this.responseJSON['rooms'], (room) => {
      return new FlatVariant(room['value'], room['title']);
    });
  }
  
  /** @returns {FinishVariant[]} */
  getFinishVariants() {
    return this.responseJSON['finish'];
  }
  
  /** @returns {FinishVariant[]} */
  getHousingShortNamesVariants() {
    return map(this.responseJSON['housingShortNames'], (room) => {
      return new HousingShortNamesVariant(room['value'], room['title']);
    });
  }

  /** @returns {Number} */
  getMinFloor() {
    return this.responseJSON['floorMin'];
  }

  /** @returns {Number} */
  getMaxFloor() {
    return this.responseJSON['floorMax'];
  }

  /** @returns {Number} */
  getSpaceMin() {
    return Math.floor(this.responseJSON['spaceMin']);
  }

  /** @returns {Number} */
  getSpaceMax() {
    return Math.ceil(this.responseJSON['spaceMax']);
  }

  /** @returns {Number} */
  getPriceMin() {
    return Math.floor(this.responseJSON['priceMin'] / 1000000);
  }

  /** @returns {Number} */
  getPriceMax() {
    return Math.ceil(this.responseJSON['priceMax'] / 1000000);
  }
}



// WEBPACK FOOTER //
// ./js/api/GetFilterParamsResponse.js